/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentityCluster } from './IdentityCluster';
import {
    IdentityClusterFromJSON,
    IdentityClusterFromJSONTyped,
    IdentityClusterToJSON,
    IdentityClusterToJSONTyped,
} from './IdentityCluster';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface IdentityClusterResponse
 */
export interface IdentityClusterResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityClusterResponse
     */
    success?: boolean;
    /**
     * 
     * @type {IdentityCluster}
     * @memberof IdentityClusterResponse
     */
    data?: IdentityCluster;
    /**
     * 
     * @type {string}
     * @memberof IdentityClusterResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityClusterResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof IdentityClusterResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof IdentityClusterResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the IdentityClusterResponse interface.
 */
export function instanceOfIdentityClusterResponse(value: object): value is IdentityClusterResponse {
    return true;
}

export function IdentityClusterResponseFromJSON(json: any): IdentityClusterResponse {
    return IdentityClusterResponseFromJSONTyped(json, false);
}

export function IdentityClusterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityClusterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : IdentityClusterFromJSON(json['data']),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function IdentityClusterResponseToJSON(json: any): IdentityClusterResponse {
    return IdentityClusterResponseToJSONTyped(json, false);
}

export function IdentityClusterResponseToJSONTyped(value?: IdentityClusterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': IdentityClusterToJSON(value['data']),
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

